export default function () {
  this.existsRegister('/v1/search/specialities', (data, meta) => {
    // Selecionando todas as Especialidades
    this.optionsSpecialities = data
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/form/resources/mounted.js